import React from "react"
import { InsufficientData, Label, NotUsed } from "client/components"
import { After, FormGroupStyled } from "./styled"

interface FormatViewProps {
    title: string
    value: string | null | false
    tableView: boolean
    after?: string
}
const FormatView = ({
    title,
    value,
    tableView,
    after = null,
}: FormatViewProps) => (
    <FormGroupStyled inline tableView={tableView}>
        {
            title && <Label row>{`${title}:`}</Label>
        }

        {value === null && <NotUsed />}
        {value === false && <InsufficientData />}

        {value && <span>{value}</span>}

        {value && after && <After>{after}</After>}
    </FormGroupStyled>
)

export default FormatView
